import { useEffect } from 'react';
import { CallAPI } from 'actions/General';
import messageAlertGreyIcon from 'assets/images/icons/message-alert-grey.svg';
import messageAlertBlueIcon from 'assets/images/icons/message-alert-blue.svg';
import messageAlertRedIcon from 'assets/images/icons/message-alert-red.svg';

const elementCommentIconHook = (
  displayedHtml,
  reportContainerRef,
  webReportInfo,
  handleSubmissionElementCommentClick,
) => {
  const fetchAndApplyCommentStatuses = async () => {
    const container = reportContainerRef.current;
    if (!container) return;

    const result = await CallAPI('GET_SUBMISSION_ELEMENTS_COMMENTS_READ_STATUS', {
      submissionId: webReportInfo.submissionId,
    });

    const lookup = {};
    if (result.status) {
      result.data.forEach((item) => {
        const key =
          item.sectionRepetitionNumber != null
            ? `${item.elementGlobalId}_${item.sectionRepetitionNumber}`
            : item.elementGlobalId;

        lookup[key] = {
          read: item.isMessagesRead,
          count: item.count,
        };
      });
    }

    const elementCommentIcons = container.querySelectorAll('.comment-icon');

    elementCommentIcons.forEach((icon) => {
      const imgEl = icon.querySelector('img');
      if (!imgEl) return;

      const elementGlobalId = icon.getAttribute('data-element-global-id');
      const sectionRepetitionNumber = icon.getAttribute('data-section-repetition-number');

      const key = sectionRepetitionNumber
        ? `${elementGlobalId}_${sectionRepetitionNumber}`
        : elementGlobalId;
      const status = lookup[key];

      let imgSrc = messageAlertGreyIcon;
      icon.classList.remove('has-comment-unread');

      if (status?.count > 0) {
        if (!status.read) {
          icon.classList.add('has-comment-unread');
          imgSrc = messageAlertRedIcon;
        } else {
          imgSrc = messageAlertBlueIcon;
        }
      }

      imgEl.src = imgSrc;
      icon.style.display = 'flex';
    });
  };

  useEffect(() => {
    const container = reportContainerRef.current;
    if (!container || !displayedHtml) return;

    const clickHandler = (event) => {
      const icon = event.target.closest('.comment-icon');
      if (!icon) return;

      const fieldId = icon.getAttribute('data-element-global-id');
      const sectionRepetitionNumber = icon.getAttribute('data-section-repetition-number');
      handleSubmissionElementCommentClick(fieldId, sectionRepetitionNumber);
    };
    container.addEventListener('click', clickHandler);

    return () => {
      container.removeEventListener('click', clickHandler);
    };
  }, [displayedHtml]);

  useEffect(() => {
    if (displayedHtml) fetchAndApplyCommentStatuses();
  }, [displayedHtml]);
};

export default elementCommentIconHook;
